export const colors = {
  neutral: {
    0: '#FFFFFF',
    50: '#E7ECF1',
    200: '#C4CCD8',
    400: '#ABB5C5',
    500: '#727F96',
    700: '#3F4B66',
    800: '#0A2540',
  },
  brand: {
    500: '#635BFF',
    800: '#0A2540',
  },
};

export const borderRadius = {
  small: '4px',
  medium: '8px',
  large: '12px',
};

export const transitions = {
  default: '150ms cubic-bezier(0.215,0.61,0.355,1)',
};
